<template>
  <base-modal
    id="item-zoom-modal"
    class="d-flex flex-column modal-size justify-content-between"
    :class="{ 'fullscreen-modal': !responsive.md }"
    title=""
    centered
    :show="show"
    :show-close-button="responsive.md"
    @closed="onClose"
  >
    <template #default>
      <!-- Mobile template -->
      <template
        v-if="!responsive.md"
      >
        <div class="fullscreen-modal__content">
          <div>
            <span
              class="clickable p-3 button-back"
              @click="onClose"
            >
              <base-icon icon="mobile-back" />
            </span>
            <div class="img position-relative d-flex justify-content-center align-items-center">
              <base-like-button
                v-if="canLike && !isVid"
                :value="currentLike"
                @input="onLikeChanged"
              />
              <div v-if="!isVid">
                <base-loading
                  v-if="isLoadingIMG"
                  label=""
                  :show="true"
                />
                <img
                  v-show="!isLoadingIMG"
                  v-srcset
                  class="media"
                  :src="`${selectedItem.image}?w=${imageWidth}&h=${imageHeight}&fit=fill&fill=solid&fill-color=FAF9F7`"
                  @load="onIMGLoaded"
                >
              </div>
              <div v-else>
                <video
                  :key="`${selectedItem.file}?w=600&h=600&fit=fill&fill=solid&fill-color=FAF9F7`"
                  class="media"
                  controls
                >
                  <source
                    :src="`${selectedItem.file}?w=600&h=600&fit=fill&fill=solid&fill-color=FAF9F7`"
                    type="video/mp4"
                  >
                </video>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-between description">
            <div class="p-4 d-flex">
              <div class="ml-2">
                <base-text
                  medium
                  class="d-flex align-items-center description__row"
                >
                  <base-like-button
                    v-if="canLike"
                    :show-icon="true"
                    :value="currentLike"
                    @input="onInput"
                  />
                  <span v-if="selectedItem.total_likes">
                    Liked by {{ selectedItem.total_likes }}
                    {{ selectedItem.total_likes === 1? 'other': 'others' }}
                  </span>
                </base-text>

                <div
                  v-if="selectedItem.uploader"
                  class="d-flex justify-content-start description__row"
                >
                  <base-text medium>
                    {{ `Posted by: ${selectedItem.uploader}` }}
                  </base-text>
                </div>
                <base-text
                  medium
                  class="description__row"
                >
                  {{ getCreatedDate(selectedItem) }}
                </base-text>
                <div class="d-flex justify-content-start">
                  <base-text
                    medium
                    v-html="selectedItem.description ? selectedItem.description : ''"
                  />
                </div>
              </div>
            </div>
            <div class="arrows d-flex justify-content-between w-100">
              <div
                v-show="value !== 0"
                class="left clickable"
                @click="decreaseIndex"
              >
                <base-icon icon="mobile-arrow-left" />
              </div>
              <div
                v-show="value !== count - 1"
                class="right clickable"
                @click="increaseIndex"
              >
                <base-icon icon="mobile-arrow-right" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template
        v-else
      >
        <div
          v-if="loading"
          class="mt-4"
        >
          <base-skeleton no-background>
            <div
              class="skeleton__item"
              style="width: 100%; height: 480px"
            />
            <div class="skeleton__item w-25 ml-4" />
            <div class="skeleton__item w-25 ml-4" />
            <div class="skeleton__item w-25 ml-4" />
          </base-skeleton>
        </div>
        <div v-else>
          <template v-if="selectedItem">
            <div class="image-container d-flex justify-content-center position-relative align-items-center pt-5 h-75">
              <base-like-button
                v-if="canLike && !isVid"
                :value="currentLike"
                @input="onLikeChanged"
              />
              <div class="left-arrow">
                <base-icon
                  v-if="value !== 0"
                  icon="carousel-left"
                  @click="decreaseIndex"
                />
              </div>
              <div v-if="!isVid">
                <div
                  v-if="isLoadingIMG"
                  class="loading"
                >
                  <font-awesome-icon
                    class="ml-1"
                    icon="spinner"
                    spin
                  />
                </div>
                <img
                  v-show="!isLoadingIMG"
                  v-srcset
                  class="media"
                  :src="`${selectedItem.image}?w=${imageWidth}&h=${imageHeight}&fit=fillmax&fill=solid&fill-color=FAF9F7`"
                  @load="onIMGLoaded"
                >
              </div>
              <div v-else>
                <video
                  :key="`${selectedItem.file}?w=600&h=600&fit=fillmax&fill=solid&fill-color=FAF9F7`"
                  class="media"
                  controls
                >
                  <source
                    :src="`${selectedItem.file}?w=600&h=600&fit=fillmax&fill=solid&fill-color=FAF9F7`"
                    type="video/mp4"
                  >
                </video>
              </div>
              <div class="right-arrow">
                <base-icon
                  v-if="value !== count - 1"
                  icon="carousel-right"
                  @click="increaseIndex"
                />
              </div>
            </div>
            <div
              style="font-size: 14px"
              class="w-100 p-3 h-25"
            >
              <div class="d-flex">
                <!-- Like icon -->
                <base-like-button
                  v-if="canLike"
                  :show-icon="true"
                  :value="currentLike"
                  @input="onInput"
                />

                <!-- Text goes here -->
                <div class="ml-2">
                  <base-text
                    v-if="selectedItem.total_likes"
                    light
                  >
                    Liked by {{ selectedItem.total_likes }}
                    {{ selectedItem.total_likes === 1? 'other': 'others' }}
                  </base-text>

                  <div class="d-flex justify-content-start">
                    <base-text
                      medium
                      :class="{ 'mr-2': selectedItem.uploader }"
                    >
                      {{ selectedItem.uploader ? `Posted by: ${selectedItem.uploader} ` : '' }}
                    </base-text>
                    <base-text light>
                      {{ getCreatedDate(selectedItem) }}
                    </base-text>
                  </div>
                  <div class="d-flex justify-content-start">
                    <base-text
                      light
                      v-html="selectedItem.description ? selectedItem.description : ''"
                    />
                  </div>
                </div>

                <!-- Download Button -->
                <div class="ml-auto">
                  <base-tooltip text="Download Image">
                    <base-icon
                      icon="download"
                      class="cursor-pointer"
                      @click="downloadPicture()"
                    />
                  </base-tooltip>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </template>
  </base-modal>
</template>

<script>
import axios from 'axios';
import resposive from '@/components/mixins/responsive';

export default {
  name: 'ItemsZoomModal',
  mixins: [resposive],
  props: {
    value: {
      type: Number,
      required: true,
    },
    nextPageExists: {
      type: Boolean,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isLoadingIMG: true,
      fakeLike: false,
    };
  },
  computed: {
    isVid() {
      return this.selectedItem.file_content_type === 'video/mp4';
    },
    elements() {
      return this.$store.state.collateral.items;
    },
    selectedItem() {
      return this.$store.state.collateral.items[this.value];
    },
    imageUrl() {
      return this.selectedItem.image;
    },
    canLike() {
      return this.$route.name === 'CollateralLink';
    },
    fullscreenModal() {
      console.log(this.resposive);
      const width = this.$route.query.w;
      return width ? width <= 992 : false;
    },
    imageWidth() {
      return this.fullscreenModal ? '992' : '490';
    },
    imageHeight() {
      return this.fullscreenModal ? '992' : '490';
    },
    isTest() {
      return this.$store.state.collateral.is_test;
    },
    currentLike() {
      return this.selectedItem.liked !== null || this.fakeLike;
    },
  },
  watch: {
    value() {
      this.isLoadingIMG = true;
    },
  },
  methods: {
    onIMGLoaded() {
      this.isLoadingIMG = false;
    },
    downloadPicture() {
      axios({
        url: this.selectedItem.image,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', this.createFileName(response));
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
      });
    },
    createFileName(response) {
      const extension = response.headers['content-type'].split('/')[1];
      const institutionName = this.$store.state.account.user.profile.institution.name;
      const stylistName = this.$store.state.account.user.user.first_name;
      const syncId = this.selectedItem.sync_id ? this.selectedItem.sync_id : this.selectedItem.pk;
      return `${institutionName}_${stylistName}_${syncId}.${extension}`;
    },
    increaseIndex() {
      const index = this.value + 1;
      if (index > this.elements.length - 1) {
        if (this.nextPageExists) {
          this.$emit('reached-bottom');
        }
      } else {
        this.$emit('input', this.value + 1);
      }
    },
    decreaseIndex() {
      if (this.value !== 0) {
        this.$emit('input', this.value - 1);
      }
    },
    onClose() {
      this.$emit('input', -1);
    },
    getImageName(item) {
      if (item.title !== undefined && item.title !== '') {
        return item.title;
      }
      if (item.image) {
        const splitted = item.image.split('/public/');
        if (splitted.length > 1) {
          return splitted[1];
        }
      }
      return '';
    },
    getCreatedDate(item) {
      if (item.created === null) {
        return '';
      }
      return this.$options.filters.nicedate(item.created, 'custom', 'MMMM Do, YYYY');
    },
    onInput(value) {
      this.onLikeChanged({ value });
    },
    onLikeChanged({ value, source }) {
      // It counts the first click on the big button. Next clicks just does the animation. (Instagram way)
      if (value === false && source === 'big-button') {
        return;
      }
      if (value) {
        this.selectedItem.total_likes += 1;
      } else {
        this.selectedItem.total_likes -= 1;
      }
      if (this.isTest) {
        this.fakeLike = value;
        return;
      }

      this.$emit(`${value ? '' : 'un'}like-collateral`, this.selectedItem.pk, this.selectedItem.liked);
    },
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  user-select: none;
}
.media {
  display: block;
  min-width: 470px;
  min-height: 450px;
  max-width: 570px;
  max-height: 450px;
  width: 100%;
  height: 100%;
  width: auto;
  height: auto;
}
.loading {
  height: 487px;
  width: 487px;
  background-color: $gray-light;
  display: flex;
  align-items: center;
  justify-content: center;
  & > * {
    opacity: 0.2;
  }
}
::v-deep .modal-content {
  max-width: 100%;
}
::v-deep .modal-body {
  padding: 1rem 0 10px 0;
}
.left-arrow {
  position: absolute;
  left: 3%;
  z-index: 9999;
}
.right-arrow {
  position: absolute;
  right: 3%;
  z-index: 9999;
}

.fullscreen-modal {
  min-height: 100vh;
  ::v-deep .modal-body {
    padding: 0;
  }
  ::v-deep .modal-dialog {
    max-width: unset !important;
    margin: 0;
    height: 100%;
    .modal-content {
      height: fit-content;
      min-height: 100%;
      width: unset !important;
      border-radius: 0;
      border: unset;
    }
  }

  ::v-deep .base-loading {
    width: 487px;
    height: 487px;
    max-width: 100%;
    max-height: 100%;
  }
  .button-back {
    display: block;
    width: 50px;
    margin-top: clamp(10px, 2vh, 20px);
    margin-left: clamp(6px, 2.3vw, 12px);
    > img {
      width: clamp(7px, 2.5vw, 15px);
    }
  }
  &__content {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .description {
    font-size: clamp(1em, calc(1vw/0.35), 2em);
    color: $black;
    flex-grow: 1;

    ::v-deep .base-like-button {
      $width: clamp(20px, 5vw, 100px);
      display: flex;
      align-items: center;
      margin-right: calc(#{$width}*0.25);  // 1/4 of it's size
      .base-icon {
        width: $width;
      }
    }

    &__row {
      margin-bottom: clamp(6px, 0.88vh, 16px);
    }
  }
  .arrows {
    //padding-bottom: 45px;
    padding: 0 clamp(10px, 3.2vw, 20px);
    margin-bottom: clamp(calc(60px*0.75), 7.4vh, calc(60px*1.5));
    div {
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
      &.left,&.right {
        line-height:0;
        $size: clamp(calc(46px*0.75), 12.2vw, calc(46px*1.5));
        width: $size;
        height: $size;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
      }
      &.left {
        margin-right: auto;
        margin-left: 0;
      }
      &.right {
        margin-right: 0;
        margin-left: auto;
      }
      ::v-deep .base-icon {
        width: clamp(6px, 2.5vw, 20px);
      }
    }
  }
}
</style>
